import { client } from "api";

type CustomerDetails = {
  orderId: string;
  name: string | null;
  address: string | null;
  postAddress: string | null;
  postalCode: string | null;
  assignedToCompany?: string | null;
};

export type EditCustomerDetailsRequest = CustomerDetails;
export type EditCustomerDetailsResponse = CustomerDetails;

export const editCustomerDetails = (params: EditCustomerDetailsRequest) => {
  const body: CustomerDetails = {
    orderId: params.orderId,
    name: params.name || null,
    address: params.address || null,
    postAddress: params.postAddress || null,
    postalCode: params.postalCode || null,
  };

  return client
    .post<EditCustomerDetailsResponse>(`/order/edit-customer-details`, body)
    .then((res) => res.data);
};
